import { render } from "./InfoLogistica.vue?vue&type=template&id=d2b282f2&scoped=true"
import script from "./InfoLogistica.vue?vue&type=script&lang=js"
export * from "./InfoLogistica.vue?vue&type=script&lang=js"

import "./InfoLogistica.vue?vue&type=style&index=0&id=d2b282f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b282f2"]])

export default __exports__